import { useState, useEffect } from "react";

const StarRating = () => (
  <img
    src="https://togo.uxper.co/wp-content/uploads/2025/04/Frame-48096550.svg"
    alt="5 stars"
    className="h-4 w-auto"
  />
);

const reviews = [
  {
    id: 1,
    date: "24 Jul 2024",
    title: "The theme works perfectly and looks great",
    body: "It works perfect and has many functions included where other themes needs to use plugins. The support can't be better. All my issues were answered within 24 hours. Great theme, great support!!!",
    avatar: "https://togo.uxper.co/wp-content/uploads/2025/04/people-4.png",
    name: "Sani Laura",
    location: "Spain",
  },
  {
    id: 2,
    date: "25 Jan 2025",
    title: "Excellent theme and excellent support 🙂",
    body: "Great product and great post purchase support from Jennie and the team. They are extremely fast with communication and have been able to provide custom development work to help us achieve functionality.",
    avatar: "https://togo.uxper.co/wp-content/uploads/2025/04/people-5.png",
    name: "Laura Susam",
    location: "United Kingdom",
  },
  {
    id: 3,
    date: "4 Apr 2025",
    title: "The best theme for WordPress. Very fast support.",
    body: "Amazing theme and what really amazes me is the support you get after you purchase this. They are quick, support with high details and explanation. It really amazes me. Would give 10 out of 5 stars on this.",
    avatar: "https://togo.uxper.co/wp-content/uploads/2025/04/Image.png",
    name: "Kevin Dun",
    location: "Italy",
  },
];

const ReviewCard = ({ review, index }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 150 * index);
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div
      className={`bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-500 flex flex-col gap-4 border border-gray-100 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
      style={{ transition: "opacity 0.5s ease, transform 0.5s ease, box-shadow 0.3s ease" }}
    >
      {/* Stars + Date */}
      <div className="flex items-center justify-between">
        <StarRating />
        <span className="text-xs text-gray-400">{review.date}</span>
      </div>

      {/* Title */}
      <h6 className="text-gray-900 font-semibold text-base leading-snug">
        {review.title}
      </h6>

      {/* Body */}
      <p className="text-gray-500 text-sm leading-relaxed flex-1">{review.body}</p>

      {/* Author */}
      <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
        <img
          src={review.avatar}
          alt={review.name}
          className="w-12 h-12 rounded-full object-cover flex-shrink-0"
        />
        <div>
          <h6 className="text-gray-800 font-semibold text-sm">{review.name}</h6>
          <p className="text-gray-400 text-xs">{review.location}</p>
        </div>
      </div>
    </div>
  );
};

const PeopleLoveUs = () => {
  const [headerVisible, setHeaderVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHeaderVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-10 px-4 sm:px-8 lg:px-20">
      <div className=" mx-auto">

        {/* Header */}
        <div
          className={`mb-10 transition-all duration-600 ${
            headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transition: "opacity 0.6s ease, transform 0.6s ease" }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            People love us
          </h2>

          {/* TripAdvisor Badge */}
          <div className="flex items-center gap-3 flex-wrap">
            <img
              src="https://togo.uxper.co/wp-content/uploads/2025/04/Tripadvisor_logo.svg"
              alt="Tripadvisor"
              className="h-8 w-auto"
            />
            <StarRating />
            <span className="text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-full px-3 py-1 shadow-sm">
              500+ reviews
            </span>
          </div>
        </div>

        {/* Review Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <ReviewCard key={review.id} review={review} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PeopleLoveUs;